import { useState } from 'react';

import {
  useDispatch,
  useSelector,
} from 'react-redux';

import { Search as SearchIcon } from 'react-feather';

import {
  Box,
  Button,
  Card,
  CardContent,
  InputAdornment,
  SvgIcon,
  TextField,
} from '@material-ui/core';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import PerfectScrollbar from 'react-perfect-scrollbar';

import {
  DatePicker,
  LocalizationProvider,
} from '@mui/x-date-pickers';

import { Settings, Download, Cached } from '@material-ui/icons';

import { PermissionAction } from 'src/actions/permission.acction';

const PermissionListToolbar = (props) => {
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false);
  const { isLoading } = useSelector(state => state.app);

  const [values, setValues] = useState({
    name: "",
  });

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });

    onLookup({[event.target.name]: event.target.value});
  };

  const onLookup = (immediatelyPayload = {}) => {
    const payload = {
      page: 'no_update',
      limit: 'no_update',
      name: typeof immediatelyPayload.name !== 'undefined' ? immediatelyPayload.name : values.name,
    };
    dispatch(PermissionAction.updateFilter(payload));
    dispatch(PermissionAction.list())
  };

  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      onLookup();
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box {...props}>
      <Box sx={{ mt: 3 }}>
        <Card className="filter_card">
          <CardContent>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <PerfectScrollbar>
                <Box sx={{ maxWidth: 500 }}>
                  <TextField
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SvgIcon
                            fontSize="small"
                            color="action"
                          >
                            <SearchIcon />
                          </SvgIcon>
                        </InputAdornment>
                      )
                    }}
                    name="name"
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    value={values.name}
                    placeholder="Tìm kiếm quyền"
                    variant="outlined"
                  />
                </Box>
              </PerfectScrollbar>
            </LocalizationProvider>
          </CardContent>
        </Card>
        <Card>
          <div className='functional-btn-container'>
            <Button
              color="primary"
              variant="contained"
              onClick={onLookup}
              style={{ background: !isLoading ? 'transparent' : 'url(/static/images/loading.gif) no-repeat center center / contain', height: '20px', padding: 0, marginTop: 0, width: '20px', minWidth: '20px', marginLeft: '5px', backgroundColor: 'transparent', fontWeight: 'normal', fontSize: '20px'}}
            >
              {!isLoading ? <Cached style={{ color: "#3498db" }} /> : ''}
            </Button>
          </div>
        </Card>
      </Box>
    </Box>
  )
}

export default PermissionListToolbar;
